import { DbConstants } from '@/const'
import { IMaterialPriceData } from './IMaterialPriceData'

export class MaterialPriceUtil {
    private static userLocale = navigator.language
    private static eurFormatter = new Intl.NumberFormat(MaterialPriceUtil.userLocale, { style: 'currency', currency: 'EUR' })

    private data: IMaterialPriceData
    private currency: string
    private localizer: (id: string) => string
    private unitLocalizer: (id: string) => string

    private priceFormatter: Intl.NumberFormat

    constructor(data: IMaterialPriceData,
        currency: string,
        localizer: (id: string) => string,
        unitLocalizer: (id: string) => string) {
        this.data = data
        this.currency = currency
        this.localizer = localizer
        this.unitLocalizer = unitLocalizer

        this.priceFormatter = currency == 'EUR'
            ? MaterialPriceUtil.eurFormatter
            : new Intl.NumberFormat(MaterialPriceUtil.userLocale, { style: 'currency', currency, currencyDisplay: 'code' })
    }

    private specialPriceText(): string | null {
        if (this.isDiscontinued() || this.data.isSparePart !== true) return '-'
        if (this.hasPriceOnRequest()) return this.localizer('onRequest')

        return null
    }

    private priceQtyAndUnit(): string {
        const data = this.data
        return data.priceQtyUnit == null
            ? `${data.priceQty}`
            : `${data.priceQty} ${this.unitLocalizer(data.priceQtyUnit)}`
    }

    hasPriceOnRequest(): boolean {
        const data = this.data
        return Boolean(data.isSparePart &&
            ((data?.price ?? 0) === 0 || (data?.priceQty ?? 0) === 0))
    }

    isDiscontinued(): boolean {
        return this.isDiscontinuedWithReplacement() || this.isDiscontinuedWithoutReplacement()
    }

    isDiscontinuedWithReplacement(): boolean {
        return this.data.sparePartStatus == DbConstants.sparePartStatusNames.discontinuedWithReplacement
    }

    isDiscontinuedWithoutReplacement(): boolean {
        return this.data.sparePartStatus == DbConstants.sparePartStatusNames.discontinuedNoReplacement
    }

    formattedRawPrice(): string {
        return this.data?.price
            ? this.priceFormatter.format(this.data.price)
            : ''
    }

    formattedPrice(): string {
        const specialText = this.specialPriceText()

        return specialText == null
            ? this.formattedRawPrice()
            : specialText
    }

    formattedPriceWithUnit() {
        const specialText = this.specialPriceText()

        if (specialText != null) {
            return specialText
        }

        return this.data?.price
            ? `${this.formattedRawPrice()} / ${this.priceQtyAndUnit()}`
            : ''
    }
}
